import data from '../data.json';
import { motion, useInView, useAnimation } from 'framer-motion';
import { SocialIcon } from 'react-social-icons'
import { useRef, useEffect } from "react";
import { TypeAnimation } from 'react-type-animation';


const ShowTitle = () => {

    return (
        <TypeAnimation sequence={[data.about.title,3000,"",1000]} className="reddit-mono-about" style={{ fontSize: "50px" }} speed={500} wrapper="span" repeat={Infinity}/>
    );
}


const About = ({ refAbout }) => {
    const ref = useRef(null);
    const isInView = useInView(ref)
    const mainControlls = useAnimation();
    useEffect(() => {
        if (isInView) {
            mainControlls.start("visible")
        }
        else {
            mainControlls.start("hidden")
        }

    }, [isInView,mainControlls])
    return (
        <div className="item" ref={refAbout}>
            <div ref={ref}>

                <motion.div className="about-motion" variants={{
                    hidden: { opacity: 0, x: -200 },
                    visible: { opacity: 1, x: 0 }
                }}
                    initial="hidden"
                    animate={mainControlls}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    whileHover={{ scale: 1 }}>
                    <div className='about-container'>
                        <ShowTitle />
                        <div style={{ fontSize: "20px" }}>{data.about.description}</div>
                        <div style={{ marginTop: "1rem", display: "flex" }}>
                            {data.about.links.map((e) => {
                                return (
                                    <motion.div
                                        initial={{ rotate: 0 }}
                                        whileHover={{ scale: 1 }}

                                    >
                                        <SocialIcon url={e.link} network={e.platform} style={{ marginRight: "1rem", height: "4rem", width: "4rem" }} />
                                    </motion.div>
                                )
                            })}
                        </div>
                        <div style={{ marginTop: "1.5rem" }}>
                            <motion.button style={{
                                backgroundColor: "#1e96fc", color: "white", height: "2rem",
                                width: "7rem", padding: "auto", paddingTop: "0.55%", borderRadius: "0.5rem",
                                fontSize: "20px", border: "2px solid transparent", display: "flex"
                            }}
                                whileHover={{ scale: 1.2 }} transition={{ duration: 0.2 }}
                            >
                                <img src="resume.png" alt="resume icon" style={{ height: "20px" }}></img>
                                <a style={{ textDecoration: "none", color: "white" }} href={data.about.resumeLink}>Resume</a>
                            </motion.button>
                        </div>
                    </div>
                    <div className='image-container'>
                        <img className="picture-img" src="picture.jpeg" alt="mypic" height="300" />
                    </div>

                </motion.div>
            </div>
        </div>
    );
}

export default About;